import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reachedSiteServiceRequest } from '../../../../actions/service_request';
import { motion } from 'framer-motion';
import { SimpleButton } from '../../../../common/Buttons/SimpleButton';

const ReachedSite = ({ isFEAssigned, id, selectedMilestones }) => {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const onReachedSiteClicked = () => {
        dispatch(reachedSiteServiceRequest({ ticketId: id, milestoneId: selectedMilestones, formName: 'reachedSite' }));
    }
    return (
        <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className='flex items-center justify-between bg-blue-50 border border-blue-100 rounded-lg p-2'
        >
            <div className="flex items-center gap-2">
                <span className="material-icons text-blue-500 text-[12px]">location_on</span>
                <p className='text-sm font-medium text-gray-700'>Have you reached the site?</p>
            </div>
            <SimpleButton
                buttonIconComponent={
                    <span className="material-icons text-sm">check</span>
                }
                btnClass={
                    `text-sm px-2 py-1 bg-scogoprimary text-white hover:bg-scogodarker rounded-md transition-all flex items-center gap-2 shadow-sm hover:shadow-md ${!isFEAssigned || formButtonLoading['reachedSite'] ? 'opacity-50 cursor-not-allowed' : ''}`
                }
                textOrComponent={'Yes, I have arrived'}
                onClick={onReachedSiteClicked}
                disabled={!isFEAssigned || formButtonLoading['reachedSite']}
            />
        </motion.div>
    )
}

export default ReachedSite;